import React from "react";
import colors from "../../../../../../config/colors";
import { isMobile } from "../../../../../../utils/common";
import { SortIndicatorContainer } from "./styles";

function SortIndicator({ order, active }) {
  return (
    <SortIndicatorContainer>
      <svg
        width={isMobile() ? window.innerWidth * 0.02 :"11"}
        height={isMobile() ? window.innerWidth * 0.02:"22"}
        viewBox="0 0 11 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.00003 20.5858C6.00003 21.4767 7.07718 21.9229 7.70714 21.2929L9.00003 20L10.5 18.5C11.0536 17.9465 10.6615 17 9.87871 17V17C9.39343 17 9.00003 16.6066 9.00003 16.1213L9.00003 1.00001C9.00003 0.447724 8.55232 8.69408e-06 8.00003 8.69408e-06H7.00003C6.44775 8.69408e-06 6.00003 0.447724 6.00003 1.00001L6.00003 17L6.00003 20.5858Z"
          fill={active && order === "DESC" ? colors.red : colors.darkBackground}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.75912 1.00203C4.75912 0.11113 3.68198 -0.335036 3.05201 0.294929L1.75912 1.58782L0.259121 3.08782C-0.294416 3.64136 0.0976213 4.58782 0.880441 4.58782V4.58782C1.36572 4.58782 1.75912 4.98122 1.75912 5.4665V20.5878C1.75912 21.1401 2.20684 21.5878 2.75912 21.5878H3.75912C4.31141 21.5878 4.75912 21.1401 4.75912 20.5878V4.58782V1.00203Z"
          fill={active && order === "ASC" ? colors.green : colors.darkBackground}
        />
      </svg>
    </SortIndicatorContainer>
  );
}
export default SortIndicator;
